"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var utils_1 = require("../utils");
var TableBody = /** @class */ (function (_super) {
    tslib_1.__extends(TableBody, _super);
    function TableBody(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.onResize = function () {
            utils_1.caf(_this.resizeRaf);
            _this.resizeRaf = utils_1.raf(function () { return _this.setState({
                offsetTop: _this.el.getBoundingClientRect().top,
                innerHeight: window.innerHeight
            }); });
        };
        _this.onScroll = function () {
            utils_1.caf(_this.scrollRaf);
            _this.resizeRaf = utils_1.raf(function () { return _this.setState({
                offsetTop: _this.el.getBoundingClientRect().top
            }); });
        };
        _this.setRef = function (el) {
            _this.el = el;
        };
        _this.scrollRaf = null;
        _this.resizeRaf = null;
        _this.el = null;
        _this.state = { offsetTop: 0, innerHeight: window.innerHeight };
        return _this;
    }
    TableBody.prototype.componentDidMount = function () {
        window.addEventListener("scroll", this.onScroll, { passive: true });
        window.addEventListener("resize", this.onResize, { passive: true });
        this.setState({ offsetTop: this.el.getBoundingClientRect().top });
    };
    TableBody.prototype.componentWillUnmount = function () {
        window.removeEventListener("scroll", this.onScroll);
        window.removeEventListener("resize", this.onResize);
    };
    TableBody.prototype.render = function () {
        var _a = this.props, children = _a.children, itemHeight = _a.itemHeight, gapItems = _a.gapItems, others = tslib_1.__rest(_a, ["children", "itemHeight", "gapItems"]);
        var _b = this.state, offsetTop = _b.offsetTop, innerHeight = _b.innerHeight;
        var gapSpace = gapItems * itemHeight;
        var topGapHeight = 0;
        var bottomGapHeight = 0;
        var isEven;
        var newChildren = React.Children.map(children, function (child, idx) {
            var itemPositionSize = idx * itemHeight;
            if (itemPositionSize + itemHeight + offsetTop + gapSpace < 0) {
                topGapHeight += itemHeight;
                return null;
            }
            else if (itemPositionSize + offsetTop - gapSpace > innerHeight) {
                bottomGapHeight += itemHeight;
                return null;
            }
            if (void 0 === isEven) {
                isEven = idx % 2 === 0;
            }
            return child;
        });
        return (React.createElement("tbody", tslib_1.__assign({}, others, { ref: this.setRef }),
            isEven ? React.createElement("tr", { style: { height: 0 } }) : null,
            React.createElement("tr", { style: { height: topGapHeight } }),
            newChildren,
            React.createElement("tr", { style: { height: bottomGapHeight } })));
    };
    TableBody.defaultProps = {
        gapItems: 10
    };
    return TableBody;
}(React.Component));
exports.default = TableBody;
